import { render } from "./org_main.vue?vue&type=template&id=d4503224&scoped=true"
import script from "./org_main.vue?vue&type=script&lang=js"
export * from "./org_main.vue?vue&type=script&lang=js"

import "./org_main.vue?vue&type=style&index=0&id=d4503224&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4503224"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
